var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyAssertions(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.6667 53.3333C46.6667 57.0152 43.6819 60 40 60C36.3181 60 33.3333 57.0152 33.3333 53.3333C33.3333 49.6514 36.3181 46.6667 40 46.6667C43.6819 46.6667 46.6667 49.6514 46.6667 53.3333ZM60 53.3333C60 64.379 51.0457 73.3333 40 73.3333C28.9543 73.3333 20 64.379 20 53.3333C20 42.2876 28.9543 33.3333 40 33.3333C51.0457 33.3333 60 42.2876 60 53.3333ZM73.3333 113.333C73.3333 120.697 67.3638 126.667 60 126.667C52.6362 126.667 46.6667 120.697 46.6667 113.333C46.6667 105.97 52.6362 100 60 100C67.3638 100 73.3333 105.97 73.3333 113.333ZM86.6667 113.333C86.6667 128.061 74.7276 140 60 140C45.2724 140 33.3333 128.061 33.3333 113.333C33.3333 98.6057 45.2724 86.6667 60 86.6667C74.7276 86.6667 86.6667 98.6057 86.6667 113.333Z",
    fill: "#22252C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.667 73.3333C117.712 73.3333 126.667 64.379 126.667 53.3333C126.667 42.2876 117.712 33.3333 106.667 33.3333C95.621 33.3333 86.6667 42.2876 86.6667 53.3333C86.6667 64.379 95.621 73.3333 106.667 73.3333ZM106.667 86.6667C125.076 86.6667 140 71.7428 140 53.3333C140 34.9238 125.076 20 106.667 20C88.2572 20 73.3333 34.9238 73.3333 53.3333C73.3333 71.7428 88.2572 86.6667 106.667 86.6667Z",
    fill: "#22252C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyAssertions);
export default __webpack_public_path__ + "static/media/empty-assertions.e6b1b5aa39cf30f19625c3b2c225f089.svg";
export { ForwardRef as ReactComponent };